import React, { useEffect, useState } from "react";
import { Icon } from "@cdk-uip/react-icon";
import Loader from "../Loader";
import NoContent from "../NoContent";
import { LinearProgress } from "@cdk-uip/react-linear-progress";
import RatingAlert from "./RatingAlert";

let intervalCall;
let blobData;
const VideoViewer = props => {
  const [duration, setDuration] = useState("");
  // const [blobData, setBlobData] = useState(null);
  const [noContent, setNoContent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [toasterShow, setToasterShow] = useState(false);
  const [toasterMessage, setToasterMessage] = useState(false);
  const [isVideoPaused, setIsVideoPaused] = useState(false);
  const [ratingOpen, setRatingOpen] = useState(false);

  let intervalCount = 0;

  useEffect(() => {
    const playpause = document.getElementById("playpause");
    playpause && playpause.classList.toggle("fade", true);
    document
      .getElementById("videoDivId")
      .addEventListener("ended", openRatingWindow, false);
  }, []);
  const openRatingWindow = () => {
    setRatingOpen(true);
  };

  const initialBlobCreation = async () => {
    let url = props.src;
    await fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      referrerPolicy: "no-referrer"
    })
      .then(response => response.blob())
      .then(blob => {
        if (blob.type.includes("video")) {
          blobData = blob;
          setIsLoading(false);
        } else {
          setNoContent(true);
          setIsLoading(false);
        }
      })
      .catch(err => {
        setNoContent(true);
        setIsLoading(false);
        setToasterMessage("Failed to download!");
        hideToaster();
      });
  };
  const videoPlayPause = () => {
    const videoElement = document.getElementById("videoDivId");
    const playpause = document.getElementById("playpause");
    if (videoElement.paused) {
      videoElement.play();
      setIsVideoPaused(false);
      videoElement.controls = true;
      playpause.classList.toggle("fade", true);
    } else {
      videoElement.pause();
      setIsVideoPaused(true);
      videoElement.controls = false;
      playpause.classList.toggle("fade", false);
    }
    return true;
  };

  const downloadVideo = async () => {
    setToasterShow(true);
    if (blobData) {
      clearInterval(intervalCall);
      const url = window.URL.createObjectURL(new Blob([blobData]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", props.name + ".mp4");
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      setToasterShow(false);
      setToasterMessage(false);
    } else if (!intervalCall) {
      initialBlobCreation();
      intervalCall = setInterval(() => {
        downloadVideo();
        intervalCount++;
      }, 1500);
    } else if (intervalCount === 20) {
      clearInterval(intervalCall);
      setToasterMessage("Failed to download!");
      hideToaster();
    }
  };

  const hideToaster = () => {
    if (intervalCall) clearInterval(intervalCall);
    setTimeout(() => {
      setToasterShow(false);
    }, 5000);
  };
  const getVideoDuration = () => {
    setTimeout(() => {
      let myVideoPlayer = document.getElementById("videoDivId");
      if (myVideoPlayer && myVideoPlayer.duration > 60)
        setDuration((myVideoPlayer.duration / 60).toFixed(2) + " mins");
      else if (myVideoPlayer && !isNaN(myVideoPlayer.duration.toFixed(2))) {
        setDuration(myVideoPlayer.duration.toFixed(2) + " seconds");
      } else if (!duration) getVideoDuration();
    }, 2000);
  };
  // const unMutefunc = () => {
  //   const videoElement = document.getElementById("videoDivId");
  //   if (videoElement) {
  //     setTimeout(() => {
  //       videoElement.muted = false;
  //       videoElement.play();
  //     }, 1000);
  //   }
  // };

  return isLoading ? (
    <Loader />
  ) : noContent ? (
    <>
      <h2 style={{ marginBottom: "5px", paddingLeft: "16px" }}>
        {props.entName}
      </h2>
      <span className="dateSpan">DATE SENT - {props.date}</span>
      <NoContent />
    </>
  ) : (
    <>
      <h2 style={{ marginBottom: "5px", paddingLeft: "16px" }}>
        {props.entName}
      </h2>
      <span className="dateSpan">DATE SENT - {props.date}</span>
      {duration ? (
        <p className="dateSpan" style={{ marginTop: "7px" }}>
          Total Duration - {duration ? duration : null}
        </p>
      ) : (
        <div
          className="loading-demo"
          style={{
            height: "15px",
            position: "relative",
            bottom: "13px",
            width: "100%",
            marginTop: "20px"
          }}
        ></div>
      )}
      <div className="videoWrapper">
        <video
          height={props.isMobile ? "240" : "450"}
          style={{ paddingLeft: props.isMobile ? "0px" : "16px" }}
          className={props.isMobile ? "videoDivMobile" : "videoDiv"}
          id="videoDivId"
          controlsList="nodownload"
          onLoad={getVideoDuration()}
          onPause={() => {
            setIsVideoPaused(true);
            const playpause = document.getElementById("playpause");
            playpause.classList.toggle("fade", false);
          }}
          onPlaying={() => {
            setIsVideoPaused(false);
            const playpause = document.getElementById("playpause");
            playpause.classList.toggle("fade", true);
          }}
          controls
          muted
          autoPlay
          playsInline
        >
          <source src={props.src} type="video/mp4" />
        </video>
        <Icon
          id="playpause"
          className="play_circle_filled-icon"
          onClick={videoPlayPause}
          style={{
            fontSize: props.isMobile ? "100px" : "120px",
            height: props.isMobile ? "50%" : "35%"
          }}
        >
          play_circle_filled
        </Icon>
      </div>
      <div className="buttonsClassPdfViewer" style={{ textAlign: "center" }}>
        {!isVideoPaused ? (
          <button className="downloadButton" onClick={videoPlayPause}>
            <Icon
              style={{ verticalAlign: "middle", paddingRight: "2px" }}
              className="cdkicon-pause"
            >
              cdkicon-pause
            </Icon>
            Pause
          </button>
        ) : (
          <button className="downloadButton" onClick={videoPlayPause}>
            <Icon
              style={{ verticalAlign: "middle", paddingRight: "2px" }}
              className="cdkicon-play_arrow"
            >
              cdkicon-play_arrow
            </Icon>
            Play
          </button>
        )}
        {toasterShow ? (
          <div
            style={{
              opacity: "0.7",
              color: "#151B25",
              fontFamily: "Roboto",
              fontSize: "16px",
              letterSpacing: "0",
              lineHeight: "24px",
              paddingLeft: "16px",
              marginTop: "5px",
              width: "15rem"
            }}
          >
            <span>Downloading...</span>
            <LinearProgress
              style={{ marginTop: "3%", width: "95%" }}
              indeterminate
            />
          </div>
        ) : (
          <button
            className="downloadButton"
            onClick={() => {
              downloadVideo();
            }}
          >
            <Icon
              style={{ verticalAlign: "middle", paddingRight: "2px" }}
              className="cdkicon-file_download"
            >
              cdkicon-file_download
            </Icon>
            Download
          </button>
        )}
      </div>
      {toasterMessage ? (
        <div
          className="storeview-notification-type"
          id="storeview-notification"
        >
          <p>{toasterMessage}</p>
        </div>
      ) : null}
      <div className="ratingsDiv">
        {!props.rating && ratingOpen ? (
          <RatingAlert isMobile={props.isMobile} data={props.data} />
        ) : null}
      </div>
    </>
  );
};

export default VideoViewer;
